import { RepositoryFactory } from '../../repositoryFactory';

const WishlistRepository = RepositoryFactory.get('wishlist');

export default {
  state: {
    items: [],
  },
  getters: {
    items: (state) => state.items,
  },
  mutations: {
    update_items(state, payload) {
      state.items = _.map(payload, 'item_code');
    },
  },
  actions: {
    add({ commit }, payload) {
      return new Promise((resolve, reject) => {
        WishlistRepository.store(payload).then((resp) => {
          commit('update_items', resp.data);
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    remove({ commit }, payload) {
      return new Promise((resolve, reject) => {
        WishlistRepository.delete(payload).then((resp) => {
          commit('update_items', resp.data);
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
  },
};
